module.exports = __webpack_public_path__ + "static/media/4_r_kartina_75.1_77.5.f5dc35ff.png";